import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReleaseHistoryPage } from './pages/release-history/release-history.page';
import { RegisterNfcTagPage } from './pages/register-nfc-tag/register-nfc-tag.page';
import { PrintJobsPage } from './pages/print-jobs/print-jobs.page';
import { DocumentPrintPage } from './pages/document-print/document-print.page';
import { PrinterListPage } from './pages/printer-list/printer-list.page';
import { GoPage } from './pages/go/go.page';
import { LoginPage } from './pages/auth/login/login.page';
import { AuthPage } from './pages/auth/auth.page';
import { TenantSelectPage } from './pages/auth/tenant-select/tenant-select.page';
import { ActivateDelegatedPage } from './pages/activate-delegated/activate-delegated.page';
import { ConsentDonePage } from './pages/consent-done/consent-done.page';
import { CaptureHistoryPage } from './pages/capture-history/capture-history.page';
import { CapturePage } from './pages/capture/capture.page';
import { authGuard } from './services/auth/auth.guard';

// Exported so a test can assert that every authGuard-protected route is accounted for in
// SanitizationService.KNOWN_RETURN_ROUTES — otherwise adding a guarded route here silently
// makes it non-returnable after sign-in.
export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    component: AuthPage,
    data: { title: '' }
  },
  {
    path: 'print-jobs',
    component: PrintJobsPage,
    data: { title: 'Print', pageType: 'PrintJobsPage' },
    canActivate: [authGuard]
  },
  {
    path: 'document-print',
    component: DocumentPrintPage,
    data: { title: 'UploadForPrinting' },
    canActivate: [authGuard]
  },
  {
    path: 'printer-list',
    component: PrinterListPage,
    data: { title: 'Printers' },
    canActivate: [authGuard]
  },
  {
    path: 'capture',
    component: CapturePage,
    data: { title: 'Capture' },
    canActivate: [authGuard]
  },
  {
    path: 'recents',
    component: PrintJobsPage,
    data: { title: 'Recents', pageType: 'RecentPrintJobsPage' },
    canActivate: [authGuard]
  },
  {
    path: 'release-history',
    component: ReleaseHistoryPage,
    data: { title: 'PrintHistory' },
    canActivate: [authGuard]
  },
  {
    path: 'capture-history',
    component: CaptureHistoryPage,
    data: { title: 'CaptureHistory' },
    canActivate: [authGuard]
  },
  {
    path: 'tenant-select',
    component: TenantSelectPage,
    data: { title: 'ChangeHome' },
    canActivate: [authGuard]
  },
  {
    path: 'go',
    component: GoPage,
    data: { title: 'CardsCodesAndConsents' },
    canActivate: [authGuard]
  },
  {
    path: 'register-nfc-tag',
    component: RegisterNfcTagPage,
    data: { title: 'RegisterNfcTag' },
    canActivate: [authGuard]
  },
  {
    path: 'sign-in',
    component: LoginPage,
    data: { title: '' }
  },
  {
    path: 'activate-delegated',
    component: ActivateDelegatedPage,
    data: { title: '' },
    canActivate: [authGuard]
  },
  // No authGuard: reached from Microsoft's redirect, on native in the system browser where
  // there is no Printix session.
  {
    path: 'consent-done',
    component: ConsentDonePage,
    data: { title: '' }
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }